import { TbError404 } from "react-icons/tb";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen min-h-[100dvh] flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 px-4 py-10">

      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-blue-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -right-16 h-80 w-80 rounded-full bg-indigo-500/20 blur-3xl"></div>

      <div className="rise relative w-full max-w-[480px] rounded-3xl bg-white p-8 text-center shadow-2xl shadow-slate-950/40 ring-1 ring-white/10 sm:p-10">

        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-blue-50 text-blue-500 ring-1 ring-blue-100">
          <TbError404 size={44} />
        </div>

        <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.16em] text-blue-500">Error 404</p>
        <h1 className="mt-2 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Page not found</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-500">
          Sorry, we couldn&rsquo;t find the page you&rsquo;re looking for. It may have been moved or no longer exists.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="/"
            className="inline-flex min-h-[44px] grow items-center justify-center rounded-xl bg-gradient-to-b from-blue-500 to-blue-600 px-4 text-sm font-bold text-white shadow-lg shadow-blue-600/25 transition hover:from-blue-600 hover:to-blue-700">
            Go back home
          </a>
          <a
            href="https://kptd.ph/remote#contact"
            className="inline-flex min-h-[44px] grow items-center justify-center rounded-xl bg-white px-4 text-sm font-bold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-50">
            Contact support
          </a>
        </div>

      </div>
    </div>
  )
}
